import { CtaBtnAlignment as r } from "@nextgen-web-framework/all";
import { ComponentType as f } from "../../registries/types/propTypes.js";
import { CTAType as n } from "../../../components/ImageWithOptionalCTA/types/enum.js";
const T = (t) => {
  const i = Array.isArray(t == null ? void 0 : t.image_with_optional_cta) ? t == null ? void 0 : t.image_with_optional_cta[0] : t == null ? void 0 : t.image_with_optional_cta;
  let a = {
    componentType: f.image_with_optional_cta,
    rounded: !1,
    bgColor: "transparent",
    config: { rounded: !1, width: 100 },
    imgList: [{ alt: "", image_file: {}, viewport: [], _metadata: {} }],
    link: {}
  };
  if (i != null && i.image) {
    const {
      cta: m,
      image: { images: l }
      // required when other properties are available.
      // ...restImageConfig
    } = i, { type: e, button_title: o, url: _, target: g, ...c } = m;
    a = {
      ...a,
      imgList: l,
      link: {
        url: _,
        target: g
      }
    }, a.button = {
      ...c,
      alignment: r.BOTTOM_CENTER,
      borderDistance: 24,
      title: e === n.IMAGE || e === n.NONE ? "" : o
    };
  }
  return a;
};
export {
  T as default
};
//# sourceMappingURL=imageWithOptionalCTA-transformer.js.map
